import React from 'react';

// Hidden inputs that Jornaya (LeadiD) and TrustedForm write into.
//
// These MUST sit inside a real <form> element. TrustedForm's script walks the
// document for forms and populates its certificate field within them — a bare
// hidden input floating in a <div> is never found, and the lead posts with an
// empty certificate URL. Several of our pages build multi-step flows out of
// plain divs rather than a <form>, so this wrapper supplies the element the
// vendor scripts look for without changing how those pages submit.
//
// Read the values back with readCertificationFields() rather than indexing
// getElementsByName(...)[0]: TrustedForm often appends its OWN input to the
// form instead of reusing the one below, leaving this placeholder empty while
// the real certificate sits in a sibling field.
//
// Render this ONCE per page, at the top level, and keep it mounted for the
// whole flow so the certificate observes the entire session.
export function LeadTrackingFields() {
  return <form
  // Deliberately NOT aria-hidden or display:none. TrustedForm skips forms
  // it considers hidden from the user, and a skipped form never receives
  // the certificate field.
  name="lead_certification"
  // Never actually submitted — the page posts the lead itself.
  onSubmit={e => e.preventDefault()}
  // Not display:none — a hidden form risks being skipped by the vendor
  // scripts. It contains only hidden inputs, so it renders at zero height.
  data-id="element-543" data-mp="12l9zzchdhino">
      <input type="hidden" name="leadid_token" value="" data-id="element-544" data-mp="1qhdzhnta66lc" />
      <input type="hidden" name="xxTrustedFormCertUrl" value="" data-id="element-545" data-mp="1v95ss63tmqf6" />
      <input type="hidden" name="xxTrustedFormPingUrl" value="" data-id="element-546" data-mp="1v9nxlr4jucyp" />
    </form>;
}